import {} from '@mui/material'

// material-ui

// project imports
import ViewPlayerAccessListComponent from 'features/view/player/access/list/component/view-player-access-list-component'

// ==============================|| PROFILE 3 ||============================== //

// styles
const Profile3 = () => {
  return (
    <>
      <ViewPlayerAccessListComponent />
    </>
  )
}

export default Profile3
